import React, { Component } from 'react';
import { IsAdmin } from "../RightsService"

export default class SourceNameCellRenderer extends Component {

    render() {
        return IsAdmin() ? this.renderButton() : this.renderStatic()
    }

    renderStatic() {
        return (
            <span>
                {this.props.value}
            </span>
        );
    }

    renderButton() {
        return (
            <span>
                <button className="btn btn-link" onClick={() => this.props.linkClicked(this.props.data)}>{this.props.value}</button>
            </span>
        );
    }
}